import {Component, Input, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdminService } from '../../../admin/admin.service';
import { DataToolsSettingsService } from '../../data-tools-settings.service';
import {WeightService} from '../weight.service';
import {IModelReference} from '../weights-interfaces';

@Component({
  selector: 'app-weight-value-selector',
  templateUrl: './weight-value-selector.component.html',
  imports: [
    FormsModule
  ],
  styleUrls: ['./weight-value-selector.component.scss']
})
export class WeightValueSelectorComponent implements OnInit {
  @Input() reference: IModelReference;
  maxWeight = 5;
  minWeight = 0;

  constructor(
    public weightService: WeightService,
    private adminService: AdminService,
    private dataToolsSettingsService: DataToolsSettingsService
  ) { }

  ngOnInit() {
  }

  change(): void {
    this.weightService.hasChanged[this.reference.entity] = true;
    this.weightService.weightsChanged.next(true);
    this.dataToolsSettingsService.finderScriptRequired.next(this.reference.entity);
  }

  validate(entity: string, weightField: string): void {
    if (!this.weightService.weights[entity][weightField]) {
      this.weightService.weights[entity][weightField] = 0;
      return;
    }
    if (this.weightService.weights[entity][weightField] > this.maxWeight) {
      this.weightService.weights[entity][weightField] = this.maxWeight;
      return;
    }
  }

  get isDisabled() {
    return this.adminService.isInLiteMode() && this.reference.weightField.includes('custom');
  }

}
